module.exports = __webpack_public_path__ + "img/cic.6134482f.jpg";